import tmpls from 'modules/HandlebarsTemplates';

const API = {
  GetWallAds: 'https://ads.mljsv.com/api/GetWallAds',
  ViewCounterUp: 'https://ads.mljsv.com/api/ViewCounterUp'
};

// okinawa ads
const previousData = {
  isSpotWall: null,
  currentWallType: null,
  mwAds: null, // map wall ads
  swAds: null, // spot wall ads
  bound: {}
};

// ===================================
// EVENTS
$(document).on('click', '.countOkiAds', e => {
  const ads_id = $(e.currentTarget).data('adsid');
  const client_type = getClientType();
  const from_screen = previousData.isSpotWall ? 'spot_wall' : 'map_wall';
  const user_id = getUserId();

  const data = {
    ads_id,
    client_type,
    from_screen,
    user_id
  };

  console.log(data);

  $.ajax({
    url: API.ViewCounterUp,
    type: 'POST',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    data
  });
});

// ===================================
// FUNCTIONS
// this should be in view or sth
const getUserId = () => {
  return (Gdata.Profile.ori && Gdata.Profile.ori._id) || 0;
};
const getClientType = () => {
  if (MobileDevice.IsMobile) {
    return MobileDevice.DeviceOS === 0 ? 'ios' : 'android';
  }
  return 'web';
};
const getImageType = () => {
  return MobileDevice.IsMobile && MobileDevice.DeviceType === 1 ? 1 : 0;
};
const getSpotBounds = () => {
  const distance = 0.05; //km

  const count = Math.ceil(Gdata.CurrentSpots.ori.length / 2);
  const user_id = getUserId();
  const client_type = getClientType();
  const image_type = getImageType();

  const newBounds = new google.maps.LatLngBounds();

  Gdata.CurrentSpots.ori.forEach(({ latitude, longitude }) => {
    newBounds.extend({
      lat: parseFloat(latitude),
      lng: parseFloat(longitude)
    });
  });

  let ne = newBounds.getNorthEast();
  let sw = newBounds.getSouthWest();
  ne = window.extendLatlngByDistance({
    latitude: ne.lat(),
    longitude: ne.lng(),
    bearing: 45,
    distance
  });
  sw = window.extendLatlngByDistance({
    latitude: sw.lat(),
    longitude: sw.lng(),
    bearing: 225,
    distance
  });

  const obj = {
    north: ne.lat,
    east: ne.lng,
    south: sw.lat,
    west: sw.lng,
    image_type,
    count,
    user_id,
    client_type
  };

  // // ============================
  // // extra
  // var { north, east, south, west } = obj;
  // var map = MainMap.gmap;

  // new google.maps.Polyline({
  //   map,
  //   path: [
  //     {
  //       lat: north,
  //       lng: east
  //     },
  //     {
  //       lat: south,
  //       lng: east
  //     },
  //     {
  //       lat: south,
  //       lng: west
  //     },
  //     {
  //       lat: north,
  //       lng: west
  //     },
  //     {
  //       lat: north,
  //       lng: east
  //     }
  //   ]
  // });
  // // extra
  // // ============================

  return obj;
};

export const getOkinawaAds = async () => {
  if (!doOkinawaAds()) {
    return;
  }

  try {
    const {
      north,
      east,
      south,
      west,
      image_type,
      count,
      user_id,
      client_type
    } = getSpotBounds();

    if (
      north === previousData.bound.north &&
      east === previousData.bound.east &&
      south === previousData.bound.south &&
      west === previousData.bound.west
    ) {
      // same with previous data, do nothing
      return;
    }
    previousData.bound = { north, east, south, west };

    // call api or sth
    previousData.mwAds = await $.ajax({
      url: API.GetWallAds,
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded; charset=utf-8',
      data: {
        north_latitude: north,
        east_longitude: east,
        south_latitude: south,
        west_longitude: west,
        image_type,
        count,
        user_id,
        client_type
      }
    });
    previousData.swAds = _.cloneDeep(previousData.mwAds);

    checkOkinawaAds();
  } catch (e) {
    console.log(e);
    console.log('getOkinawaAds failure');
  }
};
window.getOkinawaAds = getOkinawaAds;

export const checkOkinawaAds = () => {
  if (!doOkinawaAds()) {
    return;
  }

  checkWallTypeAndShuffle();
  const { mwAds, swAds, currentWallType, isSpotWall } = previousData;

  // render Map Wall Ads
  if (!isSpotWall && mwAds && currentWallType !== wallType.photo) {
    renderAds($('#ArticleTemplateContainer'), mwAds);
  }

  // render Spot Wall Ads
  if (isSpotWall && swAds) {
    renderAds($('#CheckInTemplateContainer'), swAds);
  }
};
window.checkOkinawaAds = checkOkinawaAds;

const doOkinawaAds = () => {
  return (
    AS.showOkinawaAds &&
    Gdata.CurrentMap.ori &&
    Gdata.CurrentMap.ori[0] &&
    MapClass.checkShared(Gdata.CurrentMap.ori[0].share_id) &&
    Gdata.CurrentMap.ori[0].special_contents &&
    _.indexOf(Gdata.CurrentMap.ori[0].special_contents, 'naha-bus-station') > -1
  );
};

const checkWallTypeAndShuffle = () => {
  const { isSpotWall, currentWallType, mwAds, swAds } = previousData;

  if (SpotWall && SpotWall.isSpotWall !== isSpotWall) {
    // shuffle
    previousData.swAds = _.shuffle(swAds);
    hideAds(previousData.swAds);
    previousData.isSpotWall = SpotWall.isSpotWall;
  }

  if (wallType.current !== currentWallType) {
    // shuffle
    previousData.mwAds = _.shuffle(mwAds);
    hideAds(previousData.mwAds);
    previousData.currentWallType = wallType.current;
  }
};

const renderAds = (container, ads) => {
  let pushAfter = 0;
  const articleCards = container.children('.articleCard').not('.noItemCard')
    .length;
  if (articleCards > 1) {
    pushAfter = 1;
  }
  let adsToShow = Math.ceil(articleCards / 2);

  _.forEach(ads.ads, adObj => {
    if (adsToShow < 1) {
      return false;
    }

    const { active } = adObj;

    if (!active) {
      adObj.active = true;
      const pushAfterElm = container.children(`.articleCard:eq(${pushAfter})`);
      if (pushAfterElm.length) {
        container
          .children(`.articleCard:eq(${pushAfter})`)
          .after(tmpls.hbtOkiAds(adObj));
      }
    }

    pushAfter += 2;
    adsToShow--;
  });
};

const hideAds = ads => {
  ads.forEach(adObj => {
    adObj.active = false;
  });
};

// =============================================
// =============================================
// =============================================
// =============================================
// const testAPI = (duration = 1000) =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve(testData);
//     }, duration);
//   });

// let testData = [
//   {
//     ads_id: 3,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_bar_640x300.png',
//     link_url: 'https://www.mplf.net/',
//     alt_text: ''
//   },
//   {
//     ads_id: 5,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/b9820d918b65491c2246a194ba877ba7.png',
//     link_url: 'https://www.yahoo.co.jp',
//     alt_text: ''
//   },
//   {
//     ads_id: 2,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_nan_640x300.jpg',
//     link_url: 'https://www.google.com',
//     alt_text: ''
//   },
//   {
//     ads_id: 3,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_bar_640x300.png',
//     link_url: 'https://www.mplf.net/',
//     alt_text: ''
//   },
//   {
//     ads_id: 2,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_nan_640x300.jpg',
//     link_url: 'https://www.google.com',
//     alt_text: ''
//   },
//   {
//     ads_id: 5,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/b9820d918b65491c2246a194ba877ba7.png',
//     link_url: 'https://www.yahoo.co.jp',
//     alt_text: ''
//   },
//   {
//     ads_id: 3,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_bar_640x300.png',
//     link_url: 'https://www.mplf.net/',
//     alt_text: ''
//   },
//   {
//     ads_id: 5,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/b9820d918b65491c2246a194ba877ba7.png',
//     link_url: 'https://www.yahoo.co.jp',
//     alt_text: ''
//   },
//   {
//     ads_id: 2,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_nan_640x300.jpg',
//     link_url: 'https://www.google.com',
//     alt_text: ''
//   },
//   {
//     ads_id: 3,
//     image_url:
//       'https://s3-ap-northeast-1.amazonaws.com/s3.mljsv.com/images/ad_bar_640x300.png',
//     link_url: 'https://www.mplf.net/',
//     alt_text: ''
//   }
// ];
